import {
  Array,
  Boolean,
  Dictionary,
  Optional,
  Record as RTRecord,
  String,
  Union,
  Unknown
} from 'runtypes'
import { HeightClass } from 'shared/types/toolkit'
import { StyleMap } from 'site/Renderer/hooks/useStyleMap'
import { Component } from 'site/shared/types'

export type Tab = {
  uuid: string
  des: string
  complement: string
  components?: Component[]
}

export type TabsContentProps = {
  props: {
    items: Record<string, Tab>
    highlightColor?: string
    textColor?: string
    styleMap?: StyleMap
    contentContainerStyleMap?: StyleMap
    showSeparators?: boolean
    justifyContent?: string
    heightClassMap?: Record<string, HeightClass>
  }
}

export type TabsContentItemProps = {
  items: Record<string, Tab>
  currentKey: string
  textColor?: string
}

const Tab = RTRecord({
  uuid: String,
  des: String,
  complement: String
})

const TabComponents = RTRecord({
  uuid: String,
  components: Array(Unknown)
})

export const TabsContentTypeGuard = RTRecord({
  items: Dictionary(Union(Tab, TabComponents), String),
  highlightColor: Optional(String),
  textColor: Optional(String),
  styleMap: Optional(Unknown),
  contentContainerStyleMap: Optional(Unknown),
  heightClassMap: Optional(Unknown),
  showSeparators: Optional(Boolean)
})
